// src/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/app-icon.png";

const Footer = () => {
  return (
    <footer className="aesthetic-footer">
      <div className="container text-center">
        <div className="footer-brand">
          <img
            src={logo}
            alt="Logo"
            width="45"
            height="45"
            className="rounded-circle"
          />
          <span className="fw-black">Tokenly</span>
        </div>

        <div className="footer-nav">
          <Link to="/" className="footer-link">Home</Link>
          <Link to="/about" className="footer-link">About Us</Link>
          {/* <Link to="/alldoctors" className="footer-link">Doctors</Link> */}
          <Link to="/terms" className="footer-link">Terms</Link>
          <Link to="/privacy" className="footer-link">Privacy</Link>
        </div>

        <div className="social-links">
          <a href="https://www.instagram.com/biswaasdigital/" className="social-btn" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-instagram" />
          </a>
          <a href="https://www.youtube.com/@Biswaasenterprises" className="social-btn" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-youtube" />
          </a>
          <a href="/" className="social-btn" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-linkedin-in" />
          </a>
          <a href="https://www.facebook.com/biswaasdigital/" className="social-btn" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-facebook-f" />
          </a>
        </div>

        <div className="footer-divider" />

        <div className="d-flex flex-column align-items-center">
          <p className="small text-white-50 mb-2">
            &copy; 2025 Tokenly Inc. All rights reserved.
          </p>
          <div className="credit-line">
            Built with love by <a href="https://digitalwebsite.in/" target="_blank" rel="noopener noreferrer">DigitalWebsiteStudio</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
